<template>
    <b-table
        v-if="products"
        hover
        :items="items"
        :fields="fields"
    >

        <template v-slot:cell(product_name)="data">
            <span>{{ data.item.product.getFilteredName() }}</span>
        </template>

        <template v-slot:cell(preview)="data">
            <document-preview v-if="data.item.document" :document="data.item.document" :cache="false" :width="100"></document-preview>
        </template>

        <template v-slot:cell(document)="data">
            <upload-button
                :pre_loaded_document="data.item.document"
                :editable="true"
                @onUploaded="(document) => onUploaded(data.item, data.index, document)"
                @onDelete="(document) => onDelete(data.item, data.index, document)"
                :deletable="false"
            >
            </upload-button>
        </template>

    </b-table>
</template>

<script>
  import ToastNotifications from "../shared/mixins/ToastNotifications";
  import UploadButton from "../documents/UploadButton";
  import Product from "../../models/Product";
  import DocumentPreview from "../documents/DocumentPreview";
  import Document from "../../models/Document";

  export default {
    name: 'ProductImageTable',
    components: {DocumentPreview, UploadButton},
    mixins: [ToastNotifications],
    props: {
      products: {
        default: function () {
          return null;
        }
      },
    },
    data() {
      return {
        items: [],
        fields: [
          {key: 'product_name', label: 'Product'},
          {key: 'preview', label: 'Preview'},
          {key: 'document', label: 'Image'},
        ],
      };
    },
    watch: {},
    methods: {
      onUploaded: function(item, key, document) {
        const match = (item.document && document && item.document.id === document.id);
        item = {
          product: item.product,
          document: document,
        };
        this.items.splice(key, 1, item);
        if(match) {
          return;
        }
        this.detachImages(item.product).then(() => {
          this.attachImage(item.product, document).then(() => {
            this.quickSuccessToast('Attached Image', item.product.name + ' image was uploaded successfully.')
          });
        });
      },
      onDelete: function(item, key, document) {
        item = {
          product: item.product,
          document: null,
        };
        this.items.splice(key, 1, item);
        this.detachImages(item.product).then(() => {
          this.quickSuccessToast('Detached Image', item.product.name + ' image was detached.')
        });
      },
      detachImages(product) {
        return Document.api().fetchProductDocuments(product.id, 'image').then((response) => {
          let documents = response.entities[Document.entity] ? response.entities[Document.entity] : [];
          let promises = [];
          documents.forEach((document) => {
            promises.push(Document.api().detachProductDocument(product.id, document.id, 'image'));
          });
          return Promise.all(promises);
        });
      },
      attachImage(product, document) {
        return Document.api().attachProductDocument(product.id, document.id, 'image');
      },
      showPreview(key) {
        this[key] = true;
      }
    },
    mounted() {
      if(this.products) {
        this.products.forEach((product) => {
          this.items.push({
            product,
            document: product.getPrimaryImage()
          });
        });
      }
    }
  }
</script>